import styles from './styles.module.scss'

export function LoginInput(props) {
  const { label, type, placeholder, onChange } = props
  
  return (
    <div key={label} className={styles.inputWrapper}>
      <label>{label}</label>
      <input
        type={type}
        placeholder={placeholder}
        onChange={onChange}
        maxLength={32}
      />
    </div>
  )
}